import React, { PropTypes } from 'react';

export default function Counter({ counter, addCounter, removeCounter }) {
  return (
    <div>
      <div>Counter: {counter}</div>
      <div>
        <button onClick={addCounter}>+</button>
        <button onClick={removeCounter}>-</button>
      </div>
    </div>
  );
}

Counter.propTypes = {
  counter: PropTypes.number.isRequired,
  addCounter: PropTypes.func.isRequired,
  removeCounter: PropTypes.func.isRequired,
};
